var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBA74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lamp",
    x1: 20,
    x2: 44,
    y1: 13,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97316"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334155",
    d: "M25 9h14v8H25z",
    rx: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lamp)",
    d: "M20 17h24l5 20H15l5-20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7ED",
    d: "M20 37h24c-1 9-5 15-12 15s-11-6-12-15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F97316",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M11 30 5 27M53 30l6-3M15 47l-5 5M49 47l5 5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA580C",
    d: "M27 37h10v6H27z",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.4dc7efcf0f14279b71a8990ea7f176f5.svg";
export { ForwardRef as ReactComponent };